import React from "react";
import { Link } from "react-router-dom";

// CSS
import "../../css/black-link.css";

class BlackLink extends React.PureComponent {
	render() {
		return (
			<Link to={this.props.href} className="black-link">
				{this.props.children}
			</Link>
		);
	}
}

export default BlackLink;



// WEBPACK FOOTER //
// ./src/components/utils/BlackLink.js